/** Les mots du détail d'une quête : la page et son squelette posent les mêmes intitulés. */
export const QUEST_DETAIL_TEXTS = {
    fallbackTitle: "Quête",
    locked: "Pas encore débloquées",
    done: "Terminées",
    missing: "Quête introuvable",
}
